import styled from "styled-components";

export const ActionCardContentContainer = styled.div`
  display: flex;
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const VerticalDivider = styled.div`
  width: 1px;
  background-color: #cccccc;
  margin-top: 2%;
  margin-bottom: 3%;
  @media (max-width: 768px) {
    width: 95%;
    height: 1px;
  }
`;
